<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";
    import CopyIcon from "../Icons/CopyIcon.svelte";
    import ExternalLinkIcon from "../Icons/ExternalLinkIcon.svelte";
    import XIcon from "../Icons/XIcon.svelte";
    import { CoWebsite } from "../../WebRtc/CoWebsite/CoWebsite";
    import { JitsiCoWebsite } from "../../WebRtc/CoWebsite/JitsiCoWebsite";
    import { BBBCoWebsite } from "../../WebRtc/CoWebsite/BBBCoWebsite";
    import { ICON_URL } from "../../Enum/EnvironmentVariable";
    import jitsiIcon from "../images/jitsi.png";
    import meetingIcon from "../images/meeting.svg";
    import LoaderIcon from "../Icons/LoaderIcon.svelte";
    import LL from "../../../i18n/i18n-svelte";
    import PopUpCopyUrl from "../PopUp/PopUpCopyUrl.svelte";
    import { popupStore } from "../../Stores/PopupStore";
    import { analyticsClient } from "../../Administration/AnalyticsClient";

    export let coWebsite: CoWebsite;
    export let isLoading = false;
    export let active = false;

    let isDuplicable = true;
    let isJitsi: boolean = coWebsite instanceof JitsiCoWebsite;
    let isBBB: boolean = coWebsite instanceof BBBCoWebsite;
    let cowebsiteName: string;
    let alt: string;
    let srcSimpleCowebsite = `${ICON_URL}/icon?url=${encodeURIComponent(
        coWebsite.getUrl().toString()
    )}&size=64..96..256&fallback_icon_color=14304c`;
    let url: string;
    let srcJitsi = jitsiIcon;
    let srcMeeting = meetingIcon;

    const dispatch = createEventDispatcher<{
        close: void;
        copy: void;
    }>();

    onMount(() => {
        if (isJitsi) {
            isDuplicable = true;
        } else if (isBBB) {
            isDuplicable = true;
        } else {
            alt = coWebsite.getUrl().hostname;
            cowebsiteName = coWebsite
                .getUrl()
                .toString()
                .replace(/.+\/\/|www.|\..+/g, "");
            cowebsiteName = cowebsiteName.charAt(0).toUpperCase() + cowebsiteName.slice(1);
            isDuplicable = true;
        }
    });

    function closeTab() {
        dispatch("close");
        analyticsClient.closeCowebsite();
    }

    function toggleActive() {
        if (active === true) {
            active = active;
        } else {
            active = !active;
            analyticsClient.switchCowebsite();
        }
    }

    function copyUrl() {
        url = coWebsite.getUrl().toString();
        navigator.clipboard.writeText(url).catch((e) => console.error(e));
        analyticsClient.copyCowebsiteLink();
        dispatch("copy");
        popupStore.addPopup(PopUpCopyUrl, {}, "popupCopyUrl");
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class="text flex items-center px-2 rounded transition-all hover:stroke-white {active
        ? 'text-contrast tab justify-between bg-contrast/80'
        : 'text-white cursor-pointer tab'}"
    on:click={toggleActive}
    on:click={() => (active = !active)}
>
    {#if !isLoading}
        <div class="h-6 w-6 animate-pulse rounded-sm {active ? 'bg-contrast/10' : 'bg-white/20'}">
            <LoaderIcon
                size="24"
                color1={active ? "stroke-contrast" : "stroke-white"}
                color2={active ? "stroke-contrast" : "stroke-white"}
            />
        </div>
    {/if}

    <div class="flex justify-around items-center w-full">
        <div class="flex gap-0.5">
            {#if coWebsite.isClosable() === true}
                <button
                    class="group btn btn-danger btn-sm transition-all aspect-ratio "
                    on:click={closeTab}
                >
                    <XIcon
                        height="h-6"
                        width="w-6"
                        strokeColor={active ? "stroke-white" : "stroke-white"}
                        hover={active ? "stroke-white" : ""}
                    />
                </button>
            {/if}
        </div>
    </div>
</div>

<style>
    @media (max-width: 768px) {
        .tab {
            padding-right: 1.5rem;
        }
    }
</style>
